import { apiClient, unwrap } from '@services/api';
import type { Campaign } from '@/types';

export const campaignService = {
  async getCampaigns(): Promise<Campaign[]> {
    const res = await apiClient.get<Campaign[]>('/wholesaler/campaign');
    return unwrap(res);
  },

  async createCampaign(data: Partial<Campaign>): Promise<Campaign> {
    const res = await apiClient.post<Campaign>('/wholesaler/campaign', data);
    return unwrap(res);
  },

  async updateCampaign(id: string, data: Partial<Campaign>): Promise<Campaign> {
    const res = await apiClient.patch<Campaign>(`/wholesaler/campaign/${id}`, data);
    return unwrap(res);
  },

  async toggleCampaign(id: string): Promise<{ id: string; isActive: boolean }> {
    const res = await apiClient.post<{ id: string; isActive: boolean }>(
      `/wholesaler/campaign/${id}/toggle`,
    );
    return unwrap(res);
  },

  async deleteCampaign(id: string): Promise<void> {
    await apiClient.delete(`/wholesaler/campaign/${id}`);
  },
};
